import { Link } from 'react-router-dom';
import classNames from 'classnames';

import { useFirebaseAuth } from '../../../../global/FirebaseProvider/FirebaseProvider';
import { ROUTE_UNLIMITED } from '../../../config/routes';
import useSubscriptionPlans from '../../../../../hooks/useSubscriptionPlans';

import './UnlimitedShortcutBannerCard.scss';

const UnlimitedShortcutBannerCard = ({
  className,
  trackerProps = {},
}) => {
  const { isLoading: isLoadingFirebaseAuth } = useFirebaseAuth();
  const {
    isLoading: isLoadingPlans, planValue, planPrevValue, planInterval,
  } = useSubscriptionPlans();

  const isLoading = isLoadingFirebaseAuth || isLoadingPlans;

  if (isLoading || !planValue || !planInterval) {
    return null;
  }

  return (
    <Link
      className={classNames('UnlimitedShortcutBannerCard', className)}
      to={ROUTE_UNLIMITED}
      {...trackerProps}
    >
      <div className="UnlimitedShortcutBannerCard__container">
        <div className="UnlimitedShortcutBannerCard__content">
          <div className="UnlimitedShortcutBannerCard__text">
            Go Unlimited
            {' '}
            {planPrevValue > 0 && (
              <>
                <span className="UnlimitedShortcutBannerCard__text--prev">
                  $
                  {planPrevValue}
                </span>
                {' '}
              </>
            )}
            $
            {planValue}
            /
            {planInterval}
          </div>
        </div>
      </div>
    </Link>
  );
};

export default UnlimitedShortcutBannerCard;
